import React from 'react';

// Direct signup (Nic 2026-10-26): they made an account on their own with no
// lead before it. Worked like any Signing Up card, but never counted as a
// lead on Lead Metrics. Server rule: server/lib/directSignups.js.
export const isDirectSignupLead = (lead) => lead?.leadSourceSystem === 'direct_signup';

const DirectSignupPill = ({ lead }) =>
  isDirectSignupLead(lead) ? (
    <span
      title="Made an account on their own, with no lead before it. Not counted as a lead."
      className="inline-flex shrink-0 items-center self-center rounded-full bg-teal-50 px-1.5 py-px text-[10.5px] font-semibold text-teal-700 dark:bg-teal-500/15 dark:text-teal-300"
    >
      Direct signup
    </span>
  ) : null;

export default DirectSignupPill;
